import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import { wrapUrlSafe } from './language_support_util';

const buildSignupUrl = (href: string, languageRegionCode: LanguageRegionCode) => {
  const returnTo = `returnTo=${encodeURIComponent(href)}`;
  return wrapUrlSafe(`/signup?${returnTo}`, languageRegionCode);
};

export { buildSignupUrl };
